import { i18n } from '@/plugins/i18n'
import { StoreStatus } from '@/constants'
import { UserStatus } from '@/constants'
import { userStatusOption } from '@/common/data'
import { invertKeyValues } from '@/common/objects'
import { MediaType, MediaStatus } from '@/constants'

export const userStatusStr = (status) => {
    let statusKey = Object.keys(UserStatus).find(
        key => UserStatus[key] === status
    )

    if (statusKey === undefined) {
        return
    }

    return i18n.t(`user.statuses.${statusKey.toLowerCase()}`)
}

export const userStatusColor = (status) => {
    let colors = {
        [UserStatus.ACTIVE]: 'success',
        [UserStatus.BLOCK]: 'secondary',
        [UserStatus.PENDING]: 'warning',
        [UserStatus.REMOVED]: 'danger',
        [UserStatus.REMOVED_WHEN_PENDING]: 'danger'
    }

    return colors[status] ? colors[status] : 'undefined'
}

export const UserStatusConst = UserStatus

export const userInputClass = (status) => {
    const obj = userStatusOption.find(obj => obj.value === status)

    return obj ? obj.style : ''
}

export const typeStr = (type) => {
    const typeStr = invertKeyValues(MediaType)[type]

    return typeStr ? i18n.t(`media.types.${typeStr.toLowerCase()}`) : 'undefined'
}

export const mediaStatusColor = (status) => {
    const colors = {
        [MediaStatus.PENDING]: 'warning',
        [MediaStatus.APPROVED]: 'success',
        [MediaStatus.REJECTED]: 'danger',
    }

    return colors[status] ? colors[status] : 'undefined'
}

export const mediaStatusStr = (status) => {
    const statusStr = invertKeyValues(MediaStatus)[status]

    return statusStr ? i18n.t(`media.statuses.${statusStr.toLowerCase()}`) : 'undefined'
}



export const storeStatusStr = (status) => {
    const str = invertKeyValues(StoreStatus)[status]

    return str ? i18n.t(`store.statuses.${str.toLowerCase()}`) : ''
}

export const storeStatusColor = (status) => {
    const colors = {
        [StoreStatus.PENDING]: 'warning',
        [StoreStatus.ACTIVE]: 'success',
        [StoreStatus.REJECTED]: 'danger',
        [StoreStatus.ADD_COMMISSIONS]: 'affili-coral',
        [StoreStatus.ADD_PROMOTIONS]: 'affili-coral',
    }

    return colors[status] ? colors[status] : 'undefined'
}